import { SpoolDto, UserSpoolDto } from '../../../types/spool-local';
import { useWeb3React } from '@web3-react/core';
// import moment from 'moment';
import { useContext } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import appContext from '../../../context/app/appContext';
import { getIncentivizeEarningsTotal } from '../../../helpers/sdkHelper';
import { sleep } from '../../../web3/utils';
import { USER_SPOOLS } from '../app/data';

// const INCENTIVIZED_REWARDS_FAKE_TOKENS = ['0xece2b4cb29cf6ee46f52cbdcc17890f60b6bbf07'];

const useUserSpools = () => {
    const { account, chainId } = useWeb3React();

    const { sdk, setSelectedSpool } = useContext(appContext);

    const { mutate: globalMutate } = useSWRConfig();

    const { data, error, mutate } = useSWR(
        // sdk && account ? ['userSpools', account, chainId] : null,
        ['userSpools', account, chainId],
        async (_, userAddress) => {
            return USER_SPOOLS;
            // const spools = await sdk!.spools.getUserSpools(userAddress!);

            // return spools.map((spool) => ({
            //     ...spool,
            //     incentivizedRewards: spool.incentivizedRewards.filter(
            //         (incentivizedReward) =>
            //             moment
            //                 .unix(+incentivizedReward.emissionEndDate)
            //                 .isAfter(moment()) &&
            //             !INCENTIVIZED_REWARDS_FAKE_TOKENS.includes(
            //                 incentivizedReward.id.toLowerCase()
            //             )
            //     ),
            //     userData: spool.userData
            //         ? {
            //               ...spool.userData,
            //               userIncentivizedRewards:
            //                   spool.userData!.userIncentivizedRewards.filter(
            //                       (incentivizedReward) =>
            //                           !INCENTIVIZED_REWARDS_FAKE_TOKENS.includes(
            //                               incentivizedReward.token.id.toLowerCase()
            //                           )
            //                   ),
            //           }
            //         : undefined,
            // })) as SpoolDto[];
        }
    );

    const update = async (spool: SpoolDto, updateKey: keyof UserSpoolDto) => {
        if (!sdk || !account) return;

        let retries = 0;
        let userSpool: SpoolDto;

        do {
            userSpool = await sdk.spools.getUserSpool(account, spool.address);
            retries++;

            if (!userSpool.userData) {
                await sleep(3000);
                continue;
            }

            // first condition checks if that spool already consists userData, then check update key and do comparison
            // second condition checks if that spool doesnt contain userData, if it doesnt exist originally, but userSpool now has userData, break the looop.
            if (
                (spool.userData &&
                    updateKey !== 'userIncentivizedRewards' &&
                    spool.userData[updateKey] !== userSpool.userData[updateKey]) ||
                (!spool.userData && userSpool.userData)
            ) {
                break;
            }

            if (spool.userData && updateKey === 'userIncentivizedRewards') {
                const previousTotal = getIncentivizeEarningsTotal(
                    spool.userData.userIncentivizedRewards
                );

                const currentTotal = getIncentivizeEarningsTotal(
                    userSpool.userData.userIncentivizedRewards
                );

                if (!previousTotal.eq(currentTotal)) {
                    break;
                }
            }

            await sleep(3000);
        } while (retries < 5);

        // updates current selected spool with latest data
        setSelectedSpool(userSpool);

        await mutate(async (spools) => {
            const filteredSpools = spools
                ? spools.filter((spool) => spool.address !== userSpool.address)
                : [];

            return [...filteredSpools, userSpool];
        }, false);

        await globalMutate(
            ['availableSpools', account],
            async (spools: SpoolDto[]) => {
                const filteredSpools = spools
                    ? spools.filter((spool) => spool.address !== userSpool.address)
                    : [];

                return [...filteredSpools, userSpool];
            },
            false
        );
    };

    return {
        userSpools: data,
        isLoading: !error && !data,
        error,
        updateUserSpool: update,
    };
};

export default useUserSpools;
